import { post } from 'api'

export const sendToContactSupport = async values => {
  const formData = new FormData()
  for (const property in values) {
    formData.append(property, values[property])
  }
  return post('/support/contact', formData)
}
